import React from "react";
import SitePage from "../SitePage";
import { MapPin, Clock, Mail, Phone, MessageCircle, ArrowRight } from "lucide-react";

const openChat = () => window.dispatchEvent(new CustomEvent("djk:open-chat"));

const ContactCard = ({ icon: Icon, label, value, href, testId }) => {
  const Component = href ? "a" : "div";
  return (
    <Component
      href={href}
      data-testid={testId}
      className="flex items-start gap-4 bg-zinc-900/40 border-2 border-zinc-800 hover:border-yellow-400 p-5 transition group"
      target={href && href.startsWith("http") ? "_blank" : undefined}
      rel={href && href.startsWith("http") ? "noopener noreferrer" : undefined}
    >
      <div className="bg-yellow-400 text-black p-2.5 shrink-0 group-hover:scale-110 transition">
        <Icon className="w-5 h-5" strokeWidth={3} />
      </div>
      <div>
        <div className="font-heading uppercase text-yellow-400 text-xs tracking-widest mb-1">{label}</div>
        <div className="text-white text-base leading-tight whitespace-pre-line">{value}</div>
      </div>
    </Component>
  );
};

export default function ContattiPage() {
  return (
    <SitePage
      testId="contatti-page"
      breadcrumb="Brand"
      breadcrumbLabel="Contatti"
      eyebrow="CONTATTI / 連絡"
      title="Scrivici,"
      accent="passa in bottega"
      subtitle="Il modo più veloce è la chat: c&apos;è Daita-chan h24 e se serve qualcuno in carne e ossa ti mette in coda per me o Silvano. In alternativa, questi sono i canali diretti."
    >
      <div className="space-y-12">
        {/* Primary CTA — Chat */}
        <div data-testid="contatti-primary-chat" className="border-4 border-yellow-400 bg-yellow-400/5 p-8">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            <div className="bg-yellow-400 text-black p-4 shrink-0">
              <MessageCircle className="w-8 h-8" strokeWidth={3} />
            </div>
            <div className="flex-1">
              <div className="font-jp text-yellow-400 text-sm tracking-widest mb-2">METODO CONSIGLIATO</div>
              <h2 className="font-heading uppercase text-3xl text-white mb-2">Apri una conversazione</h2>
              <p className="text-zinc-300 mb-4 text-sm leading-relaxed">
                Il nostro chatbot risponde subito su prodotti, disponibilità, spedizioni e ordini. Se la domanda è complessa la giro a Silvano o Filippo e ti scriviamo via email in giornata.
              </p>
              <button
                data-testid="contatti-open-chat"
                onClick={openChat}
                className="skew-btn bg-black text-yellow-400 font-heading uppercase text-sm px-6 py-3 border-2 border-yellow-400 hover:bg-yellow-400 hover:text-black transition inline-flex items-center gap-2"
              >
                <span>Apri la chat <ArrowRight className="inline w-4 h-4" strokeWidth={3} /></span>
              </button>
            </div>
          </div>
        </div>

        {/* Secondary contacts grid */}
        <div>
          <div className="font-jp text-yellow-400 text-sm tracking-widest mb-4">ALTRI CANALI</div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <ContactCard
              testId="contatti-store"
              icon={MapPin}
              label="Negozio fisico"
              value={"Viale Regina Margherita, 88\n55049 Viareggio (LU)"}
              href="https://www.google.com/maps/search/?api=1&query=Viale+Regina+Margherita+88+Viareggio"
            />
            <ContactCard
              testId="contatti-hours"
              icon={Clock}
              label="Orari"
              value={"Lun—Sab · 10:00—13:00\n15:30—19:30\nDomenica chiuso"}
            />
            <ContactCard
              testId="contatti-email"
              icon={Mail}
              label="Email"
              value="daitanjackreloaded@gmail.com"
              href="mailto:daitanjackreloaded@gmail.com"
            />
            <ContactCard
              testId="contatti-phone"
              icon={Phone}
              label="Telefono"
              value="Solo su appuntamento via chat"
            />
          </div>
        </div>

        <div className="text-center border-t-2 border-zinc-800 pt-10">
          <p className="text-zinc-500 italic max-w-xl mx-auto">
            Se ci scrivi fuori orario, ti rispondiamo appena riapriamo — di solito entro la mattina successiva.
          </p>
        </div>
      </div>
    </SitePage>
  );
}
